import axios from "axios";
import { requestError } from "../utils/RequestError";

export const getListBrandingSubmission = async (params) => {
  try {
    const res = await axios.get(`/admin/branding-submissions`, { params });
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const getBrandingSubmissionById = async (id) => {
  try {
    const res = await axios.get(`/admin/branding-submissions/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};

export const deleteBrandingSubmission = async (id) => {
  try {
    const res = await axios.delete(`/admin/branding-submissions/${id}`);
    return res.data["data"];
  } catch (error) {
    throw requestError(error);
  }
};
